import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { onceOnly } from '../../lib/onceOnly-sidecar'
import { rando } from '../../lib/rando-sidecar'
import type { ISPD } from '../../sprites/sprites'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import type { IChessParticle } from './chessParticles'

export type ChessParticleType = 'default' | 'dust' | 'rock-white' | 'rock-black'

export interface IChessParticleData {
  type: ChessParticleType
  frames: ISPD[]
  // bounceOnSurface: boolean
  accelY: number
  minTimeSeconds: number
  maxTimeSeconds: number
  playFrames: boolean
  dirXrange: [number, number]
  dirYrange: [number, number]
  sineX: number
  sineXperiod: number
  scale: number
  afterCreate: ((p: IChessParticle) => void) | null
  alpha: number
}

const _default: IChessParticleData = {
  type: 'default',
  frames: sprites.voyTileParticlesRound,
  // bounceOnSurface: true,
  accelY: 2,
  minTimeSeconds: 0,
  maxTimeSeconds: 2,
  playFrames: false,
  dirXrange: [-1, 1],
  dirYrange: [-0.1, -1],
  sineX: 0,
  sineXperiod: 0,
  afterCreate: null,
  scale: 1,
  alpha: 1,
}

const dataType = 'particles'
const dataList: IChessParticleData[] = []
const dataMapType: { [key: string]: IChessParticleData } = {}

export const get = (type: ChessParticleType) => {
  return entitiesUtils.genericGetData(dataType, dataMapType, type)
}

export const registerAll = () => {
  onceOnly.ensureCalledOnlyOnce(dataType)

  register(_default)

  register({
    type: 'dust',
    frames: sprites.chessDust,
    accelY: 0,
    minTimeSeconds: 0.75,
    maxTimeSeconds: 2.25,
    playFrames: true,
    dirXrange: [-1, 1],
    dirYrange: [-0.15, -0.5],
    alpha: 0.33,
    scale: 0.7,
    afterCreate: (p) => {
      p.fade = true
      p.shrink = true
    },
  })

  register({
    type: 'rock-white',
    frames: sprites.chessRockWite,
    accelY: 2,
    minTimeSeconds: 0.75,
    maxTimeSeconds: 2.25,
    playFrames: true,
    dirXrange: [-1, 1],
    dirYrange: [-0.15, -0.5],
    alpha: 1,
    scale: 0.7,
    afterCreate: (p) => {
      p.fade = true
      p.shrink = true
    },
  })

  register({
    type: 'rock-black',
    frames: sprites.chessRockBlack,
    accelY: 2,
    minTimeSeconds: 0.75,
    maxTimeSeconds: 2.25,
    playFrames: true,
    dirXrange: [-1, 1],
    dirYrange: [-0.15, -0.5],
    alpha: 1,
    scale: 0.7,
    afterCreate: (p) => {
      p.fade = true
      p.shrink = true
    },
  })
}
export const register = (data: Partial<IChessParticleData>) => {
  entitiesUtils.genericRegisterData(
    dataType,
    data,
    _default,
    dataList,
    dataMapType,
  )
}
